/**
 * The tbs.model.ModelLocator class works as the the singleton 
 * model for the whole application scope.
 */
const tbs_model_ModelLocator = function() {
}

tbs_model_ModelLocator.prototype = {
    //--------------------------------------------------
    // public static value
    //--------------------------------------------------
    /** 
     * The app context object
     * appContext.status The status for the context
     */
    appContext: {status:{}, resources: []},
    
    //--------------------------------------------------
    // api
    //--------------------------------------------------
    /**
     * @api
     * Set the context status within the application scope
     */
    setStatus: function(id, data) {
        this.appContext.status[id] = data;
    },
    /**
     * @api
     * Get the context status within the application scope
     */
    getStatus: function(id) {
        if (this.appContext.status[id]) return this.appContext.status[id];
        else return null;
    },
    /**
     * @api
     * Set the resource object into the resources within the application scope
     * @param res The resource object.
     */
    setResource: function(res) {
        this.appContext.resources.push(res);
    },
    /**
     * @api
     * Get the resource object from the resources according to the key-value property
     * @param key The key property.
     * @param value The value of the key property.
     * @return The matched resource object.
     */
    getResource: function(key, value) {
        var resources = this.appContext.resources;
        for (var i = 0; i < resources.length; i++) {
            var res = resources[i];
            if (res[key] && res[key] === value) {
                return res;
            }
        }
        return null;
    }
}

/**
 * The static implementation approach
 * @return The static method.
 */
var instance;
if (!instance) {
	instance = new tbs_model_ModelLocator;
}

module.exports = instance;